import moment from 'jalali-moment';
import { groupBy } from 'lodash';
import { flatArray } from '@/utils';

function collectHiddenProgramIds(
  programs: SelfMealEntity[],
  userWeekReserves: UserWeekReserveEntity[] = []
) {
  const hiddenProgramIds = new Set<number>();

  for (const program of programs) {
    for (const foodType of program.programFoodTypes ?? []) {
      if (foodType.hideInPanel && foodType.programId != null) {
        hiddenProgramIds.add(foodType.programId);
      }
    }
  }

  for (const userReserve of userWeekReserves) {
    if (userReserve.hideInPanel && userReserve.programId != null) {
      hiddenProgramIds.add(userReserve.programId);
    }
  }

  return hiddenProgramIds;
}

export function mapItems(selfPrograms: SelfProgramsEntity, date: string) {

  const startDate = moment.from(date, 'YYYY-MM-DD').locale('en');

  const programs = flatArray<SelfMealEntity[]>(selfPrograms.selfWeekPrograms);
  const hiddenProgramIds = collectHiddenProgramIds(programs, selfPrograms.userWeekReserves);
  const userWeekReserves = (selfPrograms.userWeekReserves ?? []).filter(
    (userReserve) => !hiddenProgramIds.has(userReserve.programId)
  );

  for (const program of programs) {
    if (!program.programFoodTypes || !Array.isArray(program.programFoodTypes)) {
      program.programFoodTypes = [];
    }

    program.programFoodTypes = program.programFoodTypes
      .filter((foodType) => !foodType.hideInPanel && !hiddenProgramIds.has(foodType.programId))
      .map((foodType) => {
        const userReserve = userWeekReserves.find(
          (userReserve) => foodType.programId === userReserve.programId
        );
        return { ...foodType, ...(userReserve ?? {}), hideInPanel: foodType.hideInPanel };
      });
  }

  const groupedPrograms = groupBy(programs, 'date');

  const dates = [];
  for (let i = 0; i < 7; i++) {
    dates.push(startDate.clone().add(i, 'day').format('YYYY-MM-DD'));
  }

  let groupedProgramsFilled: Dictionary<SelfMealEntity[]> = {};
  if (Object.keys(groupedPrograms).length !== 7) {
    for (const date of dates) {
      if (groupedPrograms[date]) {
        groupedProgramsFilled[date] = groupedPrograms[date];
      }
      else {
        groupedProgramsFilled[date] = [];
      }
    }
  }
  else {
    groupedProgramsFilled = groupedPrograms;
  }
  return { programs, groupedPrograms: groupedProgramsFilled };
}
